// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"175":"0ec3cb94c245f07d","619":"4c0a70816a615377","673":"77c70ed89fcc660d"}[chunkId] + ".js";
};